/* ============
 * Getters for the message module
 * ============
 *
 * The getters that are available on the
 * message module.
 */
import { clone } from '@/utils/object';

const getPatients = state => clone(state.patients);
const getIsPatientListLoading = state => clone(state.isPatientListLoading);
const getIsPatientMessageListLoading = state => clone(state.isPatientMessageListLoading);
const getPatientMessages = state => clone(state.patientMessages);
const getIsMessageSending = state => clone(state.isMessageSending);
const getPatientMessageKeys = state => clone(state.patientMessageKeys);
const getGroupedMessages = state => clone(state.groupedMessages);
const getPatientMessageTotalCount = state => clone(state.patientMessageTotalCount);
const getPatientsTotalCount = state => clone(state.patientsTotalCount);

export default {
  getPatients,
  getIsPatientListLoading,
  getIsPatientMessageListLoading,
  getPatientMessages,
  getIsMessageSending,
  getPatientMessageKeys,
  getGroupedMessages,
  getPatientMessageTotalCount,
  getPatientsTotalCount
};
